



































































































































































































import { Component, Vue, Ref } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import Sentences from "@/components/cards/Sentences.vue";
import NewSentences from "@/components/modals/NewSentence.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import { Notify, Dialog, Popup } from "vant";
import axios from "axios";
import Spiner from "@/components/englishjanala/Spiner.vue";
import Questions from "@/components/cards/ConversationQuestions.vue";
import NewQuestions from "@/components/modals/NewQuestion.vue";
import ExerciseHeader from "@/components/cards/ExerciseHeaderCard.vue";

// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {
    Sentences,
    sidebar,
    NewSentences,
    Spiner,
    Questions,
    NewQuestions,
    ExerciseHeader,
  },
})
export default class Chapter extends Vue {
  ConvId: any;
  Spiner: boolean = true;
  chap: any;
  TextChange = "";
  DivId = -1;
  EditId = -1;
  show = false;
  hover: boolean = false;
  whoEn = "";
  sentenceEn = "";
  whoBn = "";
  sentenceBn = "";
  Chapter: any = null;
  errors: any = [];
  category: any = null;
  showWords: any = true;
  Category = "conversationQuestion";
  edit_title: boolean = false;
  new_exercise: any = {
    name: null,
    id: null,
    description: null,
    shortDescription: null,
    numberQuestionsSelected: null,
    questions: [],
  };
  ShowEditInput() {
    // chapter.agreedToContribute = true;
    this.Chapter.agreedToContribute = true;
  }
  showWord() {
    this.showWords = true;
  }
  showExercise() {
    this.showWords = false;
  }
  NewSentence(sentence: any) {
    this.Chapter.sentences.push({
      id: "",
      en: sentence.sentenceEn,
      bn: sentence.sentenceBn,
      translationType: "EN_2_BN",
      phBn: "",
      whoEn: sentence.whoEn,
      whoBn: sentence.whoBn,
      description: "",
      keywords: [],
      showNarrator: false,
      isBookmarked: false,
      isUserGenerated: false,
      chapterId: "",
      conversationCategoryId: "",
      bookmarkedCategoryName: "",
      isExpandable: false,
      frequency: 0,
      weight: 0,
    });
    sentence.whoBn = sentence.whoEn = sentence.sentenceBn = sentence.sentenceEn = "";
    window.scrollTo(0, document.body.scrollHeight);
    this.UpdateChapter();
  }
  UpdateChapter() {
    const data = { category_id: this.ConversationId, chapter: this.Chapter };
    // get all category list
    // this.$emit("UpdateChapter", this.Chapter[0]);
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/UpdateConversationChapter",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Conversation Chapter is not Updated" });
      });
    Notify({ type: "success", message: "Conversation Chapter Updated" });
    // const x = 10;
  }
  //
  async mounted() {
    const catId = this.$route.params.ConversationId;
    const chapId = this.$route.params.ChapterId;
    const ides = { category_id: catId, chapter_id: chapId };

    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/GetConversationChapter",
      ides
    );
    const data = response.data;

    this.Chapter = data.chapter;
    console.log("chapter 1", this.Chapter);
    this.Chapter.agreedToContribute = false;
    console.log("res dat", response);
    this.Spiner = false;
  }

  get ConversationId() {
    this.ConvId = this.$route.params.ConversationId;
    return this.$route.params.ConversationId;
  }
  get ChapterId() {
    return this.$route.params.ChapterId;
  }

  get Conversation() {
    return data.conversationCategories.filter((item) => {
      return item.id == this.ConversationId;
    });
  }
  getImgUrl(item: any) {
    return item.imageUrl;
  }
  NewQuestion(question: any) {
    for (let i = 0; i < 4; i++) {
      if (question.answerIndices[i] == true) {
        question.answerIndices[i] = 1;
      } else question.answerIndices[i] = 0;
    }
    if (question.questionType == "TRANSLATE_REARRANGE")
      question.reorderAnswerList = question.reorderAnswerList.split(" ");
    if (typeof this.Chapter.exercise == "undefined") {
      this.CreateExercise();
    }
    this.Chapter.exercise.questions.push({
      reorderShuffleList: [],
      id: "",
      imageUrl: question.imageUrl,
      questionTitle: question.questionTitle,
      questionType: question.questionType,
      reorderAnswerList: question.reorderAnswerList,
      answerId: question.answerId,
      answerOptions: question.answerOptions,
      answerIndices: question.answerIndices,
    });

    Notify({ type: "success", message: "Question added" });
    // chapter.name = chapter.id = chapter.imageUrl = chapter.contributorName = "";
    question.questionTitle = "";
    question.imageUrl = "";
    (question.questionType = ""), (question.answerOptions = ["", "", "", ""]);
    question.answerId = 0;
    question.answerIndices = [0, 0, 0, 0];
    question.reorderAnswerList = [];

    window.scrollTo(0, document.body.scrollHeight);
    this.UpdateChapter();
  }

  CreateExercise() {
    Vue.set(this.Chapter, "exercise", this.new_exercise);
  }
}
